/**
 * Shared responsive breakpoint for the mobile/desktop split (<=768px).
 *
 * MOBILE_MEDIA_QUERY is consumed by useIsMobile (the viewport-chooser hook that
 * picks between the *Mobile and desktop screen variants) and by createStyles
 * `@media` blocks, so the magic number lives in exactly one place.
 */
export const MOBILE_MAX_WIDTH = 768;
export const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_MAX_WIDTH}px)`;
